<template>
  <div>
    <div style="margin-bottom: 1rem">
      <el-button size="mini" @click="handleAdd" type="primary">添加角色</el-button>
    </div>

    <el-table
        :data="tableData"
        stripe
        style="width: 100%">
      <el-table-column
          prop="id"
          label="ID"
          width="80">
      </el-table-column>
      <el-table-column
          prop="role_name"
          label="角色名称">
      </el-table-column>
      <el-table-column
          prop="role_code"
          label="角色编码">
      </el-table-column>
      <el-table-column
          prop="description"
          label="描述">
      </el-table-column>
      <el-table-column
          prop="created_at"
          label="创建时间">
      </el-table-column>
      <el-table-column
          label="操作"
          width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="success" @click="handleAssignPermissions(scope.row)">分配权限</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
                     :disabled="scope.row.role_code === 'admin'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current_page"
        :page-size="per_page"
        :page-sizes="[20, 30, 50, 100]"
        :pager-count="11"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
    </el-pagination>

    <!-- 添加/编辑角色对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="600px" custom-class="role-dialog">
      <el-form :model="form" :rules="formRules" ref="form" label-width="100px">
        <el-form-item label="角色名称" prop="role_name">
          <el-input v-model="form.role_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色编码" prop="role_code">
          <el-input v-model="form.role_code" autocomplete="off" :disabled="editMode"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="选择权限" v-if="!editMode">
          <el-tabs v-model="activeAddTab">
            <el-tab-pane label="API权限" name="api">
              <div class="permission-tree-container">
                <el-tree
                  :data="apiPermissionTree"
                  show-checkbox
                  node-key="id"
                  ref="addApiPermissionTree"
                  :props="treeProps">
                </el-tree>
              </div>
            </el-tab-pane>
            <el-tab-pane label="菜单权限" name="menu">
              <div class="permission-tree-container">
                <el-tree
                  :data="menuPermissionTree"
                  show-checkbox
                  node-key="id"
                  ref="addMenuPermissionTree"
                  :props="treeProps">
                </el-tree>
              </div>
            </el-tab-pane>
            <el-tab-pane label="按钮权限" name="button">
              <div class="permission-tree-container">
                <el-tree
                  :data="buttonPermissionTree"
                  show-checkbox
                  node-key="id"
                  ref="addButtonPermissionTree"
                  :props="treeProps">
            </el-tree>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分配权限对话框 -->
    <el-dialog title="分配权限" :visible.sync="assignPermissionsVisible" width="600px" custom-class="role-dialog">
      <el-form label-width="100px">
        <el-form-item label="角色名称">
          <el-input v-model="assignForm.role_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="选择权限">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="API权限" name="api">
              <div class="permission-tree-container">
                <el-tree
                  :data="apiPermissionTree"
                  show-checkbox
                  node-key="id"
                  ref="apiPermissionTree"
                  :props="treeProps"
                  :default-checked-keys="assignForm.permission_ids">
                </el-tree>
              </div>
            </el-tab-pane>
            <el-tab-pane label="菜单权限" name="menu">
              <div class="permission-tree-container">
                <el-tree
                  :data="menuPermissionTree"
                  show-checkbox
                  node-key="id"
                  ref="menuPermissionTree"
                  :props="treeProps"
                  :default-checked-keys="assignForm.permission_ids">
                </el-tree>
              </div>
            </el-tab-pane>
            <el-tab-pane label="按钮权限" name="button">
              <div class="permission-tree-container">
                <el-tree
                  :data="buttonPermissionTree"
                  show-checkbox
                  node-key="id"
                  ref="buttonPermissionTree"
                  :props="treeProps"
                  :default-checked-keys="assignForm.permission_ids">
                </el-tree>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="assignPermissionsVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitAssign">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'Role',
  data() {
    return {
      tableData: [],
      permissionTree: [],
      apiPermissionTree: [],
      menuPermissionTree: [],
      buttonPermissionTree: [],
      current_page: 1,
      per_page: 20,
      total: 0,
      dialogFormVisible: false,
      assignPermissionsVisible: false,
      editMode: false,
      activeTab: 'api',
      activeAddTab: 'api',
      form: {
        role_name: '',
        role_code: '',
        description: '',
        permission_ids: []
      },
      assignForm: {
        role_id: 0,
        role_name: '',
        permission_ids: []
      },
      formRules: {
        role_name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ],
        role_code: [
          { required: true, message: '请输入角色编码', trigger: 'blur' }
        ]
      },
      treeProps: {
        children: 'children',
        label: 'name'
      }
    };
      },
  computed: {
    dialogTitle() {
      return this.editMode ? '编辑角色' : '添加角色';
    }
  },
  mounted() {
    this.getRoleList();
    this.getPermissionTree();
  },
  methods: {
    getRoleList() {
      this.http.fetchGet(this.api.role_list, {
        page: this.current_page,
        limit: this.per_page
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.data || [];
          this.total = res.data.data.total || 0;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('获取角色列表失败');
      });
    },
    getPermissionTree(type) {
      const params = type ? { type } : {};
      this.http.fetchGet(this.api.permission_tree, params).then((res) => {
        if (res.data.code === 200) {
          if (type === 'api') {
            this.apiPermissionTree = res.data.data || [];
          } else if (type === 'menu') {
            this.menuPermissionTree = res.data.data || [];
          } else if (type === 'button') {
            this.buttonPermissionTree = res.data.data || [];
          } else {
            this.permissionTree = res.data.data || [];
          }
        }
      }).catch(err => {
        console.log(err);
      });
    },
    handleAdd() {
      this.editMode = false;
      this.form = {
        role_name: '',
        role_code: '',
        description: '',
        permission_ids: []
      };
      
      // 加载不同类型的权限树
      this.getPermissionTree('api');
      this.getPermissionTree('menu');
      this.getPermissionTree('button');
      
      this.dialogFormVisible = true;
      
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      
      // 清空所有分类树的选中状态
      this.$nextTick(() => {
        if (this.$refs.addApiPermissionTree) {
          this.$refs.addApiPermissionTree.setCheckedKeys([]);
        }
        if (this.$refs.addMenuPermissionTree) {
          this.$refs.addMenuPermissionTree.setCheckedKeys([]);
        }
        if (this.$refs.addButtonPermissionTree) {
          this.$refs.addButtonPermissionTree.setCheckedKeys([]);
        }
      });
    },
    handleEdit(row) {
      this.editMode = true;
      this.form = {
        id: row.id,
        role_name: row.role_name,
        role_code: row.role_code,
        description: row.description
      };
      this.dialogFormVisible = true;
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let permissionIds = [];
          
          // 收集添加角色时所有类型的选中权限
          if (!this.editMode) {
            if (this.$refs.addApiPermissionTree) {
              permissionIds = permissionIds.concat(this.$refs.addApiPermissionTree.getCheckedKeys());
            }
            if (this.$refs.addMenuPermissionTree) {
              permissionIds = permissionIds.concat(this.$refs.addMenuPermissionTree.getCheckedKeys());
            }
            if (this.$refs.addButtonPermissionTree) {
              permissionIds = permissionIds.concat(this.$refs.addButtonPermissionTree.getCheckedKeys());
            }
            
            // 去重
            permissionIds = Array.from(new Set(permissionIds));
          }
          
          if (this.editMode) {
            // 更新角色
            this.http.fetchPut(this.api.role_update + '/' + this.form.id, {
              role_name: this.form.role_name,
              role_code: this.form.role_code,
              description: this.form.description
            }).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('更新成功');
                this.dialogFormVisible = false;
                this.getRoleList();
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              console.log(err);
              this.$message.error('更新失败');
            });
          } else {
            // 创建角色
            this.http.fetchPost(this.api.role_create, {
              ...this.form,
              permissions: permissionIds
            }).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('添加成功');
                this.dialogFormVisible = false;
                this.getRoleList();
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              console.log(err);
              this.$message.error('添加失败');
            });
          }
        }
      });
    },
    handleAssignPermissions(row) {
      this.assignForm = {
        role_id: row.id,
        role_name: row.role_name,
        permission_ids: row.permissions ? row.permissions.map(p => p.id) : []
      };
      
      // 加载不同类型的权限树
      this.getPermissionTree('api');
      this.getPermissionTree('menu');
      this.getPermissionTree('button');
      
      this.assignPermissionsVisible = true;
      
      // 等待树加载后设置选中状态
      // 关键：只设置叶子节点为选中状态，避免父节点的选中导致所有子节点被自动勾选
      this.$nextTick(() => {
        setTimeout(() => {
          // 过滤出叶子节点（实际分配的权限）
          const leafKeys = this.getLeafKeys(this.assignForm.permission_ids);
          
          if (this.$refs.apiPermissionTree) {
            this.$refs.apiPermissionTree.setCheckedKeys(leafKeys);
          }
          if (this.$refs.menuPermissionTree) {
            this.$refs.menuPermissionTree.setCheckedKeys(leafKeys);
          }
          if (this.$refs.buttonPermissionTree) {
            this.$refs.buttonPermissionTree.setCheckedKeys(leafKeys);
          }
        }, 100);
      });
    },
    handleSubmitAssign() {
      let permissionIds = [];
      
      // 收集所有类型的选中权限
      if (this.$refs.apiPermissionTree) {
        permissionIds = permissionIds.concat(this.$refs.apiPermissionTree.getCheckedKeys());
      }
      if (this.$refs.menuPermissionTree) {
        permissionIds = permissionIds.concat(this.$refs.menuPermissionTree.getCheckedKeys());
      }
      if (this.$refs.buttonPermissionTree) {
        permissionIds = permissionIds.concat(this.$refs.buttonPermissionTree.getCheckedKeys());
      }
      
      // 去重
      permissionIds = Array.from(new Set(permissionIds));
      
      this.http.fetchPost(this.api.role_assign_permissions + '/' + this.assignForm.role_id + '/permissions', {
        permission_ids: permissionIds
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('分配权限成功');
          this.assignPermissionsVisible = false;
          this.getRoleList();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('分配权限失败');
      });
    },
    handleDelete(row) {
      this.$confirm(`确定要删除角色 ${row.role_name} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.http.fetchDel(this.api.role_delete + '/' + row.id).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('删除成功');
            this.getRoleList();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    handleSizeChange(val) {
      this.per_page = val;
      this.getRoleList();
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.getRoleList();
    },
    /**
     * 从权限ID列表中过滤出叶子节点
     * 叶子节点：在所有权限树中没有子节点的节点
     */
    getLeafKeys(permissionIds) {
      const leafKeys = [];
      const allTrees = [this.apiPermissionTree, this.menuPermissionTree, this.buttonPermissionTree];
      
      // 构建所有节点的映射（ID -> 节点对象）
      const nodeMap = new Map();
      const buildNodeMap = (nodes) => {
        nodes.forEach(node => {
          nodeMap.set(node.id, node);
          if (node.children && node.children.length > 0) {
            buildNodeMap(node.children);
          }
        });
      };
      
      allTrees.forEach(tree => {
        if (tree && tree.length > 0) {
          buildNodeMap(tree);
        }
      });
      
      // 过滤出叶子节点
      permissionIds.forEach(id => {
        const node = nodeMap.get(id);
        // 如果节点不存在或者没有子节点，则认为是叶子节点
        if (!node || !node.children || node.children.length === 0) {
          leafKeys.push(id);
        }
      });
      
      return leafKeys;
    }
  }
}
</script>

<style scoped>
/* 权限树容器 - 装饰性样式 */
.permission-tree-container {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 10px;
  background-color: #FAFAFA;
}
</style>

<style>
/* 对话框高度限制（非scoped，影响el-dialog） */
.role-dialog {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.role-dialog .el-dialog__body {
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* 对话框body的滚动条样式 */
.role-dialog .el-dialog__body::-webkit-scrollbar {
  width: 8px;
}

.role-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: #F5F5F5;
  border-radius: 4px;
}

.role-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #DCDFE6;
  border-radius: 4px;
}

.role-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #C0C4CC;
}
</style>
